module.exports = __webpack_public_path__ + "static/media/remember_12.00c4c3fe.png";